<template>
  <div>
  <h3 class="content-block openware-form-title">{{ title }}</h3>

    <DxPopup
        :drag-enabled="false"
        :hide-on-outside-click="true"
        :show-close-button="true"
        :show-title="true"

        :columns="columns"
        :column-hiding-enabled="false"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        :focused-row-enabled="true"
        title="Διαχείριση Πελάτη"
        :width="'90%'" 
        :height="'90%'"

        v-model:visible="isPopupVisible"
        titleTemplate="title"
        deferRendering="true"
        :animation="{
                        show: {
                            type: 'pop',
                            duration: 800,
                            from: {
                                scale: 0.90
                            }
                        }, 
                    }"
    >
        <DxScrollView height="100%" width="100%" ref="FormScrollViewRef">
            <ClientsForm
                ref="clientsForm"
                :client_id="selectedClientID" 
                @closePopupEvent="onClosePopupEmit">
            </ClientsForm>
        </DxScrollView>

    </DxPopup>

  <DxDataGrid
      ref="dataGrid"
      :key-expr="id"
      :data-source="CustomStoreMain"
      :columns="columns"
      :allow-column-reordering="false"
      :allow-column-resizing="false"
      :column-hiding-enabled="false"
      :column-auto-width="true"
      :show-borders="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      :focused-row-enabled="true"
      :word-wrap-enabled="true"
      :selection-filter="['appointments_frequency', '=', '3']"

      :scrolling="{ mode: 'standard' }" 
      height="auto"

      @exporting="onExporting"
      @selectionChanged="onSelectionChanged"
      @cell-prepared="onCellPrepared"
      @initialized="onGridInitialized"
  >
      <DxAdaptive :enabled="true" />

      <DxPaging 
          :enabled="true"
          :page-size="5"
      />

      <DxFilterRow :visible="true"/>

      <DxHeaderFilter :visible="true" :allowHeaderFiltering="false"/>

      <DxPager
          :visible="true"
          :allowed-page-sizes="pageSizes"
          :display-mode="displayMode"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
      />

      <DxSorting mode="multiple"/>

      <DxEditing
          :allow-updating="true"
          :allow-adding="false"
          :allow-deleting="false"

          :texts= "{
                      addRow: 'Προσθήκη',
                      deleteRow: 'Διαγραφή',
                      editRow:'Επεξεργασία',
                      saveAllChanges:'Αποθήκευση Όλων',
                      cancelAllChanges:'Ακύρωση Όλων'
                  }"
          mode="row"
      >
      </DxEditing>

      <DxToolbar>
            <DxItem locate-in-menu="auto" location="before">
                <div class ="ow-list-filters" style="display: flex;">
                    <div class="ow-list-filter">
                    <label class="filter-label" for="selectBoxYear">Έτος: </label>
                    <DxSelectBox   
                        ref="selectBoxYearRef"
                        id="selectBoxYear"
                        :data-source="CustomStoreLookup_ow_view_appointments_years"
                        value-expr="id"
                        display-expr="appointment_year"
                        placeholder="Έτος"
                        width="70"
                        :show-clear-button="false"
                        :search-enabled="false"
                        @initialized="onInitializedYear"
                        @value-changed="onValueChangedYear"
                    />
                </div>

                
                <div class="ow-list-filter">
                    <label class="filter-label" for="selectBoxYear">Πωλητής:</label>
                    <DxSelectBox
                        ref="selectBoxClientSourcesRef"
                        id="selectBoxClientSources"
                        :data-source="CustomStoreLookup_ow_client_sources"
                        value-expr="id"
                        display-expr="name"
                        :show-clear-button="true"
                        :search-enabled="false"
                        @initialized="onInitializedClientsSource"
                        @value-changed="onValueChangedClientsSource"
                    />
                </div>
                

            </div>
            </DxItem>

            <DxItem location="after">
                <DxDateBox 
                    placeholder="Ημερομηνία"
                    :show-clear-button="true"
                    :use-mask-behavior="true"
                />
            </DxItem>
            <DxItem name="exportButton" 
                :options="{
                        hint: 'Εξαγωγή δεδομένων'
                    }"
            />
      </DxToolbar>

      <!--
      <DxColumn
          data-field="app_date"
          caption="Ημερομηνία & ώρα"
          :dataType="'date'"
          :hiding-priority="140"
          width="150"
      
          :format="{  type: 'datetime',
                      formatter: (value) => value.toLocaleString('el-GR', {
                          weekday: 'long', 
                          year: 'numeric', 
                          month: 'long', 
                          day: '2-digit',
                          hour: '2-digit', 
                          minute: '2-digit',
                          second: '2-digit' 
                      })
                    }"
      >
      </DxColumn>
      -->

      <DxGroupPanel :visible="false"/>

      <DxGrouping :auto-expand-all="false"/>

      <DxColumn
          data-field="client_id"
          caption="Πελάτης"
          :hiding-priority="-1"
      >
            <DxLookup
                :data-source="CustomStoreLookup_ow_client_addresses"
                value-expr="id"
                display-expr="name"
            />
      </DxColumn>

      <DxColumn
          data-field="descr"
          caption="Συχνότητα Εργασιών / Έτος"
          data-type="number"
          width="200"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxColumn
          data-field="totalcountlastyear"
          caption="Αρ. Επισκέψεων Προηγούμενου Έτους"
          data-type="number"
          width="200"
          :hiding-priority="-1"
      >
      </DxColumn>
      
      <DxColumn
          data-field="collected_amount"
          caption="Εισπράξεις"
          data-type="number"
          width="200"
          :format="formatCurrency"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxColumn
          data-field="expected_turnover"
          caption="Αναμενόμενος Τζίρος"
          data-type="number"
          width="200"
          :format="formatCurrency"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxColumn
          data-field="client_rank_id"
          caption="Αξιολόγηση Πελάτη"
          :hiding-priority="-1"
          width="100"
      >
            <DxLookup
                :data-source="CustomStoreLookup_ow_client_ranks"
                value-expr="id"
                display-expr="name"
            />
      </DxColumn>

      <DxColumn type="buttons">
              <DxButton 
                text="Επεξεργασία2"
                icon="edit"
                hint="Επεξεργασία"
                :on-click="onCustomRowEdit"
              />

              <DxButton 
                name="delete" 
                hint="Διαγραφή" 
              />
      </DxColumn>

      <DxSummary>
        <DxTotalItem
                column="collected_amount"
                summary-type="sum"
                :value-format="formatCurrency"
                displayFormat="Σ: {0}"
        />
        <DxTotalItem
              column="expected_turnover"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
          />
      </DxSummary>

      <DxExport
          :enabled="true"
          :formats="['xlsx']"
          :texts= "{
                      exportAll: 'Εξαγωγή σε {0}',
                  }"
      />

  </DxDataGrid>

</div>

</template>

<script setup>
    import {
        DxDataGrid,
        DxColumn,
        DxEditing, 
        DxPaging, 
        DxPager,
        DxGroupPanel,
        DxGrouping,
        DxSorting,
        DxFilterRow,
        DxHeaderFilter,
        DxExport,
        DxLookup, //DxRemoteOperations, //DxRequiredRule,
        DxToolbar,
        DxItem,
        DxButton,
        DxSummary,
        DxTotalItem,
        DxAdaptive,
        //DxGroupItem
    } from 'devextreme-vue/data-grid'; 

    import 'whatwg-fetch';
    import CustomStore from 'devextreme/data/custom_store';
    //import { DxDateRangeBox } from 'devextreme-vue/date-range-box';
    //import DxDateBox from 'devextreme-vue/date-box';  
    import DxSelectBox from 'devextreme-vue/select-box'
    //import { DxLookup as DxLookupEx, DxDropDownOptions } from 'devextreme-vue/lookup'

    import DxPopup from 'devextreme-vue/popup'
    import DxScrollView from 'devextreme-vue/scroll-view'
    
    //import DataSource from 'devextreme/data/data_source'

    import OParameters from '../es-globals';

    import { ref, /*reactive, computed, onMounted */} from 'vue'

    import ClientsForm from './ow-clients-form.vue'

    //import { exportDataGrid } from 'devextreme/pdf_exporter';

    const URL_SERVICE = OParameters.Host.URI + 'ow_view_rep_totalappfrequencyyearturnover'
    const URL_SERVICE_ow_client_addresses = OParameters.Host.URI + 'ow_clients'
    const URL_SERVICE_ow_client_sources = OParameters.Host.URI + 'ow_client_sources'
    const URL_SERVICE_ow_client_ranks = OParameters.Host.URI + 'ow_client_ranks'

    const URL_SERVICE_ow_view_appointments_years = OParameters.Host.URI + 'ow_view_appointments_years'

    const dataGrid = ref(null)
    const FormScrollViewRef = ref(null)
    const clientsForm = ref(null)

    const selectedClientID = ref(null)
    const selectBoxClientSourcesRef = ref(null)
    const selectedClientsSourceID = ref(null)

    const selectBoxYearRef = ref(null)
    const selectedYear = ref(new Date().getFullYear())

    //const currentYear = ref(new Date().getFullYear()) // Get the current year
    //const currentMonth = ref(new Date().getMonth() + 1) // Get the current month (1-12)
    
    const title = 'Αναλυτική Αναφορά Εισπράξεων ανά Συχνότητα ανά Έτος και Πωλητή'
    const pageSizes = [5, 10, 20, 0]
    const isPopupVisible = ref(false)

    const formatCurrency = { 
        type: 'currency',
        currency: 'EUR', 
        useGrouping: true, 
        precision: 2 
    }

    const CustomStoreMain = new CustomStore({
        key: 'client_id',
        //loadMode: 'raw',
        load: () => {
            const clientsSources = (selectedClientsSourceID.value != null ? `&filter=client_source_id,eq,${selectedClientsSourceID.value}` : '')

            return sendRequest(URL_SERVICE + '?filter=app_year,eq,' + selectedYear.value + clientsSources)

        },
        insert: (values) => sendRequest(URL_SERVICE, 'POST', values),
        update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
        remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
        byKey: (key) => sendRequest(URL_SERVICE + "/" + encodeURIComponent(key)),
    })

    const CustomStoreLookup_ow_view_appointments_years = new CustomStore({
        key: 'id',
        loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE_ow_view_appointments_years),
        //byKey: (key) => this.sendRequest(URL_SERVICE_ow_view_appointments_years + "/" + encodeURIComponent(key)),
    })
    
    const CustomStoreLookup_ow_client_sources = new CustomStore({
        key: 'id',
        //loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE_ow_client_sources),
        byKey: (key) => sendRequest(URL_SERVICE_ow_client_sources + "/" + encodeURIComponent(key)),
    })

    const CustomStoreLookup_ow_client_ranks = new CustomStore({
        key: 'id',
        loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE_ow_client_ranks),
        byKey: (key) => sendRequest(URL_SERVICE_ow_client_ranks + "/" + encodeURIComponent(key)),
    })

    

    const CustomStoreLookup_ow_client_addresses = new CustomStore({
        key: 'id',
        //loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE_ow_client_addresses),
        byKey: (key) => sendRequest(URL_SERVICE_ow_client_addresses + "/" + encodeURIComponent(key)),
    })


    // 
    //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
    //
    const sendRequest = (url, method = 'GET', values = {}) => {
        // console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
        if (method === 'GET') {
            return fetch(url, {
                method,
                credentials: 'include',
            })
            .then(response => {
                //this.dataSourceLoaded = true;
                return response.json().then(json => {
                    if (response.ok) return json.records;
                    throw json.Message;
                });
            });
        }
        return fetch(url, {
            method,
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            credentials: 'include',
        }).then((result) => {
            if (result.ok) {
                return result.text().then((text) => text && JSON.parse(text));
            }
            return result.json().then((json) => {
                throw json.Message;
            });
        });
    }

    const onExporting = (e) => {
        OParameters.methods.exportDataGridToPdfExcel(e, title)
    }

    const onGridInitialized = () => {
        console.log('onGridInitialized')
        onInitializedYear()
    }

    const onInitializedYear = () => {
        selectedYear.value = new Date().getFullYear()
        selectBoxYearRef.value?.instance?.option('value', selectedYear.value);
    }

    const onCustomRowEdit = (e) => {
        selectedClientID.value = e.row.key

        console.log('selectedClientID.value', selectedClientID.value)
        clientsForm.value.loadFormData(selectedClientID.value)

        isPopupVisible.value = true
    }


    const onClosePopupEmit = () => {
        FormScrollViewRef.value.instance.scrollTo(0);
            isPopupVisible.value = false
        dataGrid.value?.instance?.refresh()
    }

    const onValueChangedYear = (e) => {
        selectedYear.value = e.value
        //console.log('Year change: ' + this.selectedYear)
        dataGrid.value?.instance?.refresh()
        /*
        const dataGrid = this.$refs.dataGrid.instance;
        if (dataGrid) {
            dataGrid.refresh(); // Reload the data grid
        }
        */
    }

    const onInitializedClientsSource = () => {
        selectBoxClientSourcesRef.value?.instance?.option('value', selectedClientsSourceID.value);
    }

    const onValueChangedClientsSource = (e) => {
        selectedClientsSourceID.value = e.value
        dataGrid.value?.instance?.refresh()
    }

    const onCellPrepared = (e) => {
        if (e.rowType === "data") {
            if (e.column.dataField === "client_rank_id") {
                //console.log('e.data.client_rank_id', e.data.client_rank_id)
                //console.log('e.data.sum_collected_amount > e.data.sum_collected_amount_last_year', e.data.sum_collected_amount, e.data.sum_collected_amount_last_year)
                if (e.data.client_rank_id==1) {
                    //console.log('green')
                    e.cellElement.style.cssText = "color: white; background-color: green; text-align: right;";
                } else {
                    //console.log('red')
                    e.cellElement.style.cssText = "color: white; background-color: red; text-align: right;";
                }

                switch (e.data.client_rank_id) {
                    case 1:
                        //console.log('green')
                        e.cellElement.style.cssText = "color: white; background-color: green; text-align: right;";
                        break;
                    case 2:
                        //console.log('yellow')
                        e.cellElement.style.cssText = "color: black; background-color: yellow; text-align: right;";
                        break;
                    // Add as many cases as needed
                    default:
                        //console.log('red')
                        e.cellElement.style.cssText = "color: white; background-color: red; text-align: right;";
                }
            }
        }
    }

</script>

<style lang="scss">
</style>
